import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import "../common/lib/Array.prototype.asc";
import "../common/lib/Array.prototype.desc";
import "../common/lib/Array.prototype.uniq";

const container = document.getElementById("app");
const root = ReactDOM.createRoot(container);
root.render(<App />);
